export function variantSpecRange(variants, key) {
  const values = (variants || [])
    .map(variant => Number(variant?.[key]))
    .filter(value => Number.isFinite(value) && value > 0)

  if (!values.length) return null

  return { min: Math.min(...values), max: Math.max(...values) }
}

export function formatSpecRange(range, unit) {
  if (!range) return null

  return range.min === range.max
    ? `${range.min}${unit}`
    : `${range.min}–${range.max}${unit}`
}
